export const w320 = 320;
export const w375 = 375;
export const w414 = 414;
export const w440 = 440;
export const w512 = 512;
export const w620 = 620;
export const w768 = 768;
export const w960 = 960;
export const w984 = 984;
export const w1024 = 1024;
export const w1140 = 1140;
export const w1232 = 1232;
export const w1260 = 1260;

export const MORE_320_MEDIA_QUERY = `@media screen and (min-width: ${w320}px)`;
export const MORE_375_MEDIA_QUERY = `@media screen and (min-width: ${w375}px)`;
export const MORE_440_MEDIA_QUERY = `@media screen and (min-width: ${w440}px)`;
export const MORE_512_MEDIA_QUERY = `@media screen and (min-width: ${w512}px)`;
export const MORE_620_MEDIA_QUERY = `@media screen and (min-width: ${w620}px)`;
export const MORE_768_MEDIA_QUERY = `@media screen and (min-width: ${w768}px)`;
export const MORE_960_MEDIA_QUERY = `@media screen and (min-width: ${w960}px)`;
export const MORE_984_MEDIA_QUERY = `@media screen and (min-width: ${w984}px)`;
export const MORE_1024_MEDIA_QUERY = `@media screen and (min-width: ${w1024}px)`;
export const MORE_1232_MEDIA_QUERY = `@media screen and (min-width: ${w1232}px)`;

export const LESS_1260_MEDIA_QUERY = `@media screen and (max-width: ${w1260}px)`;
export const LESS_1232_MEDIA_QUERY = `@media screen and (max-width: ${w1232}px)`;
export const LESS_1140_MEDIA_QUERY = `@media screen and (max-width: ${w1140}px)`;
export const LESS_1024_MEDIA_QUERY = `@media screen and (max-width: ${w1024}px)`;
export const LESS_984_MEDIA_QUERY = `@media screen and (max-width: ${w984}px)`;
export const LESS_960_MEDIA_QUERY = `@media screen and (max-width: ${w960}px)`;
export const LESS_768_MEDIA_QUERY = `@media screen and (max-width: ${w768}px)`;
export const LESS_620_MEDIA_QUERY = `@media screen and (max-width: ${w620}px)`;
export const LESS_512_MEDIA_QUERY = `@media screen and (max-width: ${w512}px)`;
export const LESS_414_MEDIA_QUERY = `@media screen and (max-width: ${w414}px)`;
export const LESS_375_MEDIA_QUERY = `@media screen and (max-width: ${w375}px)`;
